<template>
  <div id="app_content" class="public">
    <div
        class="jumbo"
        :style="
        'background-image: url(' +
        url('/media/image-page/about-us/customer-service.jpg') +
        ');'
      "
    ></div>
    <div class="section-wrapper">
      <div class="section-container">
        <div class="section-init">
          <div class="w-text">
            <link-page-back/>
            <div class="w-title w-title-1">
              <h1 class="mt-0">
                {{trans.get('public.about-us.title')}}
              </h1>
            </div>
            <div class="w-content">
              <p class="p-desc">
                {{trans.get('public.about-us.desc')}}
              </p>
            </div>
          </div>
        </div>

        <div class="w-sections-flex">
          <div class="section std-flex">
             <div class="content">
                <div class="texture">
                  <div class="w-image">
                    <img :src="sectionImage[1]"/>
                  </div>
                  <div class="text-content">
                    <div class="w-text">
                      <h1>
                        {{trans.get('public.about-us.customer-service.title')}}
                      </h1>
                      <p>
                        {{trans.get('public.about-us.customer-service.desc')}}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
          </div>
          <div class="section std-flex reverse">
             <div class="content">
                <div class="texture">
                  <div class="w-image">
                    <img :src="sectionImage[2]"/>
                  </div>
                  <div class="text-content">
                    <div class="w-text">
                      <h1>
                        {{trans.get('public.about-us.logistics.title')}}
                      </h1>
                      <p>
                        {{trans.get('public.about-us.logistics.desc')}}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
          </div>
          <div class="section std-flex">
             <div class="content">
                <div class="texture">
                  <div class="w-image">
                    <img :src="sectionImage[3]"/>
                  </div>
                  <div class="text-content">
                    <div class="w-text">
                      <h1>
                        {{trans.get('public.about-us.research-dev.title')}}
                      </h1>
                      <p>
                        {{trans.get('public.about-us.research-dev.desc')}}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
          </div>
<!--          <template v-for="i in 3">-->
<!--            <div-->
<!--                class="section std-flex"-->
<!--                :class="{ reverse: i % 2 === 0 }"-->
<!--                :data-section="i"-->
<!--            >-->
<!--              <div class="content">-->
<!--                <div class="texture">-->
<!--                  <div class="w-image">-->
<!--                    <img :src="sectionImage[i]"/>-->
<!--                  </div>-->
<!--                  <div class="text-content">-->
<!--                    <div class="w-text">-->
<!--                      <h1>-->
<!--                        {{-->
<!--                          $store.getters.contenuto(-->
<!--                              "about_us_sezione_" + i + "_titolo"-->
<!--                          )-->
<!--                        }}-->
<!--                      </h1>-->
<!--                      <p-->
<!--                          v-html="-->
<!--                          $store.getters.contenuto(-->
<!--                            'about_us_sezione_' + i + '_desc'-->
<!--                          )-->
<!--                        "-->
<!--                      ></p>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </template>-->
        </div>
        <!-- .w-sections-flex -->
      </div>
      <!-- .section-container -->
    </div>
    <div class="newsletter">
      <div class="section-wrapper">
        <div class="section-container">
          <form_newsletter_new/>
        </div>
      </div>
    </div>

    <!-- .section-wrapper -->
  </div>
</template>

<script>
import form_newsletter_new from "../form-newsletter-new";

export default {
  components: {
    form_newsletter_new,
  },

  data: function () {
    return {
      sectionImage: {
        1: this.url("/media/image-page/about-us/customer-service.jpg"),
        2: this.url("/media/image-page/about-us/logistica.jpg"),
        3: this.url("/media/image-page/about-us/ricerca-sviluppo.jpg"),
      },

      isMounted: false,
    };
  },

  created: function () {
    this.isMounted = true;
  },

  mounted: function () {
  },

  computed: {},

  methods: {},
};
</script>

<style lang="scss">
.w-title-1 {
  @media (min-width: 1200px) {
    width: 50%;
  }
}

#app_content.public {
  background-color: var(--black-2);
  //padding-top: 75px !important;
  padding-bottom: 1px;
  font-size: 1rem;
  @media (min-width: 1921px) {
    font-size: var(--font-size-large);
  }
  .jumbo {
    height: 480px;
    width: 100%;
    background-size: auto;
    background-position: center 33%;
  }
}

.section-container {
  width: 100%;
  height: auto;
  color: white;
  max-width: 1200px;
  margin: auto;
}

/*
 * contenuto delle sezioni allineato togliendo l'ingombro
 * del menù
*/
.section-wrapper {
  max-width: calc(100% - var(--public-menu-width));
  margin: 0 0 0 var(--public-menu-width);
}

.section-wrapper .section-container {
  max-width: 1320px;
  padding: 0 2em 0 2em;

  .section-init {
    .w-text {
      margin-top: 20px;

      .w-title {
        h1 {
          font-weight: 600;
          font-size: 28px;
          margin-bottom: 48px;
        }
      }

      .w-content {
        p {

          @media (min-width: 576px) {
            column-count: 2;
          }
        }
      }
    }
  }
}

.section.std-flex {
  padding-left: 0;
  padding-right: 0;

  .content {
    height: 100%;

    .texture {
      align-items: center;

      .text-content {
        h1 {
          font-size: 28px;
          color: var(--text-white);
        }
      }
    }
  }
}

.newsletter {
  background-color: #0e0e0e;
  width: 100vw;
}

@media screen and (max-width: 1220px) {
  .section-wrapper {
    max-width: 100%;
    margin: 0;
  }
  .section-wrapper .section-container {
    margin: 0;
    padding: 0 1em 0 1em;
  }
}

/* @media screen and (max-width:1725px) {
  .section-container {
    max-width: 1000px;
  }
}

@media screen and (max-width:1545px) {
  .section-container {
    max-width: 900px;
  }
}

@media screen and (max-width:1450px) {
  .section-container {
    max-width: 800px;
  }
} */

.w-sections-flex {
  margin-top: 4em 0;
}

.w-image img {
  display: block;
  width: 100%;
}

.text-content .w-text {
  width: 90%;
  margin: auto;
}

.section.std-flex {
  margin: 6em 0;
}

.section.std-flex .texture {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.section.std-flex.reverse .texture {
  flex-direction: row-reverse;
}

.section.std-flex .texture .text-content {
  width: 44%;
}

.section.std-flex .texture .w-image {
  width: 52%;
}

.section.std-flex .texture .text-content h1 {
  margin-top: 0;
}

.section-init .w-content p,
.section.std-flex .texture .text-content p {
  margin: 0;
  font-weight: 300;
  color: var(--text-white);
}

@media screen and (max-width: 1220px) {
  .section.std-flex .texture .text-content h1 {
    margin-top: 1em;
  }
  .section.std-flex {
    margin: 4em 0;
  }
}

@media screen and (max-width: 1370px) {
  .section.std-flex .texture .text-content,
  .section.std-flex .texture .w-image {
    width: 100%;
  }
  .w-text {
    width: 98%;
    margin: auto;
  }
  .text-content .w-text {
    width: 100%;
    margin: auto;
  }
}
</style>
